const clinician = (() => {
    const handleToggleOverlays = el => {
        const filters = el.querySelector('[data-results-filters]');
        el.querySelectorAll('[data-toggle-filters]').forEach(toggleFilters => {
            toggleFilters.addEventListener('click', () => {
                filters.classList.toggle('search-results-block__filters--open');
                document.documentElement.classList.toggle('overlay--filters');
            });
        });
    };

    return {
        handleToggleOverlays
    };
})();
ControlBinders.register(`[data-clinician-page]`, el => clinician.handleToggleOverlays(el));